import React, { Component } from 'react';

import axios from 'axios';
import {API_URL} from '../../constants';

import {BASE_URL} from '../../constants';
import {BASE_URL_RUEDAS} from '../../constants';
import {BASE_URL_SIICEX} from '../../constants';
import {CODIGO_ESTUDIOS} from '../../constants';


export default class AnalisisMercado extends Component {

    constructor(props) {
        super(props);
        this.state = { 
            resource: [],
            response: [],
            section: [],
            error: [],
            key: 0,
            sectorKey: this.props.sector,
            cssClass:''
          }
      }

    componentDidMount=()=> {
        var url = `${API_URL}StudyUX/${this.state.sectorKey}/${CODIGO_ESTUDIOS}`; 
        axios.get(url).then(response => response.data)
        .then((data) => {
          this.setState({ section: data.result, error: data.Error });
        })
        .catch(error => {
          console.log(error);
        });
    }


    render() {
        return ( 
            <div className="last-news-sector gray-bg">
            <div className="boletin__section">
                <div className="boletin__section market__section">
                    <div className="row boletin__title-row">
                        <div className="col-sm-12  boletin__title-name-section">
                            <span className=" boletin__title-name">ANÁLISIS DE MERCADO</span>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-6">
                            <div className="row last-courses__title">
                                <div className="col-sm-9 col-8">
                                    <ul id="boletin__header-title">
                                    <li className="boletin__subtitle-name ">
                                        <span className="boletin__subtitle-name--pl">ÚLTIMOS ESTUDIOS ESPECIALIZADOS</span>
                                    </li>
                                    </ul>
                                </div>
                                <div className="col-sm-3 col-4">
                                </div>
                            </div>
                            <div className="row">
                            {this.state.section.map((section, index) => (
                                (index <= 5)?(
                                <div className="col-sm-12" key={section.idestudiomercado}>
                                    <div className="last-course-item">
                                        <div className="row align-items-center">
                                            <div className="col-sm-2 col-2">
                                                <img src="img/informe-especializado.png" />
                                            </div>
                                            <div className="col-sm-6 col-6">
                                                <p className="last-course-item__title"> Informe especializado</p>
                                                <p className="last-course-item__extract">{section.titulo}</p>
                                            </div>
                                            <div className="col-sm-2 col-2">
                                                <span className="last-course-item__bookmark"><i className="far fa-bookmark"></i></span>
                                            </div>
                                            <div className="col-sm-2 col-2">
                                                <a className="dropdown-toggle last-course-item__dropdown" href="#" role="button" id="dropdownLastCourseOptions" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                    <span className="last-course-item__ellipsis"><i className="fas fa-ellipsis-h"></i></span>
                                                </a>
                                                <div className="dropdown-menu last-courses__filter-menu" aria-labelledby="dropdownLastCourseOptions">
                                                    <a target="_blank" className="dropdown-item last-courses__filter-item" href={BASE_URL_SIICEX + 'siicex/'+ section.documento}><i className="fas fa-cloud-download-alt"></i>&nbsp;Descarga</a>
                                                    {/* <a className="dropdown-item last-courses__filter-item" href="#"><i className="fas fa-share-alt"></i>&nbsp;Compartir</a>
                                                    <a className="dropdown-item last-courses__filter-item" href="#"><i className="fas fa-download"></i>&nbsp;Guardar</a> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div> 
                                </div>):("")
                            ))}
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="row last-courses__title">
                                <div className="col-sm-9 col-8">
                                    <ul id="boletin__header-title">
                                    <li className="boletin__subtitle-name ">
                                        <span className="boletin__subtitle-name--pl">ESTADÍSTICAS - PRODUCTOS DEL MES</span>
                                    </li>
                                    </ul>
                                </div>
                                <div className="col-sm-3 col-4">
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="last-course-item heightEstadistica">
                                    </div> 
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        )
    }

}